import { useEffect, useRef } from 'react'
import { useRouterState } from '@tanstack/react-router'
import { serverConfig } from '@/config/server.config'

// Must render under RouterProvider so useRouterState has router context.
export function AnalyticsRouteTracker() {
  const pathname = useRouterState({ select: (s) => s.location.pathname })
  const isInitialRender = useRef(true)

  useEffect(() => {
    if (!serverConfig.googleAnalyticsMeasurementId) {
      return
    }

    // gtag('config') already sends the initial page_view.
    if (isInitialRender.current) {
      isInitialRender.current = false
      return
    }

    window.gtag?.('event', 'page_view', {
      page_location: window.location.href,
      page_path: pathname,
      page_title: document.title,
    })
  }, [pathname])

  return null
}
